/**
 * frontend/src/pages/valuation/_railNext.ts
 *
 * VAL-UX-SMALL-1 item 1 — the side nav's NEXT marker follows the step bar order
 * (Engagement, Company, Financials, ..., Intake). `nextStep()` answers "Intake"
 * for any engagement that has not started intake, which skips Company and
 * Financials. Until a fiscal year has been read from an upload, the first step
 * not yet done is Company; after that the engine answer stands. Display only.
 */
import type { NextStep } from './_nextStep'

export function railNextRoute(
  step: NextStep | null,
  id: string,
  status: string,
  yearCount: number | null,
): string | null {
  if (!step) return null
  const startsIntake = step.route === `/valuation/${id}/intake` && status !== 'intake_in_progress'
  if (startsIntake && yearCount === 0) return `/valuation/${id}/company`
  return step.route
}
